/* eslint semi: 1, react/prop-types:1 */

import React from 'react';
import PropTypes from 'prop-types';

const ScreenshotComponent = ({ idx, imageSrc, description }) => {

    const styles = {
        image: {
            width: '100%',
            height: 'auto'
        },
        description: {
            paddingTop: 50,
            paddingLeft: 50,
            paddingRight: 50,
            paddingBotom: 50
        }
    };
    if(idx % 2 === 0) {
        return (
            <div className="row">
                <div className="col-md-7">
                    <img style={styles.image} src={imageSrc} alt={`Screenshot ${idx}`} />
                </div>
                <div className="col-md-4">
                    <p style={styles.description}>{description}</p>
                </div>
            </div>
        );
    } else {
        return (
            <div className="row">
                <div className="col-md-4">
                    <p style={styles.description}>{description}</p>
                </div>
                <div className="col-md-7">
                    <img style={styles.image} src={imageSrc} alt={`Screenshot ${idx}`} />
                </div>
            </div>
        );
    }
};
ScreenshotComponent.propTypes = {
    idx: PropTypes.number,
    imageSrc: PropTypes.string,
    description: PropTypes.string
};

export default ScreenshotComponent;



/** WEBPACK FOOTER **
 ** ./src/components/home-screenshot-component.js
 **/